import { StatusWording } from '../enums/order-status.enums';
import { SubStatusCodes, SubStatusWording } from '../enums/order-sub-status.enums';
import { SubStatusDictionary } from '../models/order-status.types';

export const SubStatusConfig: SubStatusDictionary = {
    [SubStatusCodes.SentToWarehouse]: {
        title: SubStatusWording.SentToWarehouse,
        isSubStatusInfo: true,
        groupKey: StatusWording.InWarehouse,
        order: 4,
    },
    [SubStatusCodes.ReceivedInWarehouse]: {
        title: SubStatusWording.ReceivedInWarehouse,
        isSubStatusInfo: true,
        groupKey: StatusWording.InWarehouse,
        order: 4,
    },
    [SubStatusCodes.InPreparationAsigned]: {
        title: SubStatusWording.InPreparation,
        isSubStatusInfo: true,
        groupKey: StatusWording.InWarehouse,
        order: 4,
    },
    [SubStatusCodes.InPreparationPick]: {
        title: SubStatusWording.InPreparation,
        isSubStatusInfo: true,
        groupKey: StatusWording.InWarehouse,
        order: 4,
    },
    [SubStatusCodes.Packaging]: {
        title: SubStatusWording.Packaging,
        isSubStatusInfo: true,
        groupKey: StatusWording.InWarehouse,
        order: 4,
    },
    [SubStatusCodes.ReadyToShip]: {
        title: SubStatusWording.ReadyToShip,
        isSubStatusInfo: true,
        groupKey: StatusWording.InWarehouse,
        order: 4,
    },
    [SubStatusCodes.Carrier]: {
        title: SubStatusWording.InCarrier,
        isSubStatusInfo: true,
        groupKey: StatusWording.InCarrier,
        order: 7,

    },
    [SubStatusCodes.InDistribution]: {
        title: SubStatusWording.InDistribution,
        isSubStatusInfo: true,
        groupKey: StatusWording.InCarrier,
        order: 7,
    },
    [SubStatusCodes.InStore]: {
        title: SubStatusWording.InStore,
        isSubStatusInfo: true,
        groupKey: StatusWording.ReadyToPick,
        order: 8,
    },
    [SubStatusCodes.InDroppoint]: {
        title: SubStatusWording.InDroppoint,
        isSubStatusInfo: true,
        groupKey: StatusWording.ReadyToPick,
        order: 8,
    },
    [SubStatusCodes.Rejected]: {
        isSubStatusInfo: true,
        groupKey: StatusWording.Rejected,
        order: 9,
    },
    [SubStatusCodes.Delivered]: {
        isSubStatusInfo: true,
        groupKey: StatusWording.Delivered,
        order: 10,
    },
};
